import React from "react";
import IMAGES from "../../../../constant/images";

export default function NoAppointments() {
  return (
    <div className="w-full p-3">
      <div className="w-full flex flex-col items-center justify-center p-3 text-center">
        {/* Image */}
        <img
          src={IMAGES.no_chart_data}
          alt="No Appointments"
          className="h-[140px] mb-2"
        />
      </div>
      
    </div>
  );
}
